import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, ScanLine, LayoutDashboard, Users } from "lucide-react";

export default function TopBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <header className="border-b-2 border-[#121212] bg-white" data-testid="topbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to={user && user.role === "admin" ? "/admin" : "/usher"}
          className="flex items-center gap-3"
          data-testid="topbar-logo"
        >
          <div className="w-9 h-9 bg-[#FFCC00] border-2 border-[#121212] flex items-center justify-center">
            <ScanLine className="w-5 h-5" strokeWidth={2.5} />
          </div>
          <div className="font-display font-black tracking-tighter text-xl uppercase">
            Gatekeep
          </div>
        </Link>

        <nav className="flex items-center gap-3">
          {user && user.role === "admin" && (
            <>
              <Link
                to="/admin"
                className="hidden sm:flex items-center gap-2 px-3 py-2 mono-label hover:bg-[#F4F4F5] border-2 border-transparent hover:border-[#121212]"
                data-testid="nav-admin"
              >
                <LayoutDashboard className="w-4 h-4" />
                Dashboard
              </Link>
              <Link
                to="/admin/users"
                className="hidden sm:flex items-center gap-2 px-3 py-2 mono-label hover:bg-[#F4F4F5] border-2 border-transparent hover:border-[#121212]"
                data-testid="nav-users"
              >
                <Users className="w-4 h-4" />
                Users
              </Link>
            </>
          )}
          {user && (
            <div
              className="hidden md:block mono-label text-[#121212]"
              data-testid="topbar-user"
            >
              <span className="text-[#666]">[{user.role}]</span> {user.email}
            </div>
          )}
          <button
            onClick={handleLogout}
            className="brut-btn-secondary !py-2 !px-3 flex items-center gap-2"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4" />
            <span className="hidden sm:inline">Sign out</span>
          </button>
        </nav>
      </div>
    </header>
  );
}
